import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {BaseUrl} from "../Routes/BaseUrl";
const CertificateValidation = () => {
  const [query, setQuery] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const validate = async (e) => {
    e.preventDefault();
    setError(null);
    setResult(null);

    const inputId = query.trim();
    if (!inputId) {
      setError("Please enter a certificate ID");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(
        `${BaseUrl}/api/certificates/verify/${inputId}`
      );
      console.log("Data from server:", response.data);
      setResult(response.data.data);
      if (!response?.data?.data) setError("Certificate not found");
    } catch (err) {
      setResult(null);
      setError("Certificate not found");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    // Clear previous results when user starts typing a new ID
    if (result) {
      setResult(null);
      setError(null);
    }
  };

  const handleClear = () => {
    setQuery("");
    setResult(null);
    setError(null);
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <Link to="/" className="text-sm text-blue-600 underline">
        &larr; Back
      </Link>
      <h1 className="text-2xl font-bold mt-4 mb-4">Certificate Validation</h1>
      <p className="text-gray-700 mb-6">
        Enter the certificate ID (e.g. CERT-2025-0001) to verify its status.
      </p>

      <form onSubmit={validate} className="flex gap-2">
        <input
          value={query}
          onChange={handleInputChange}
          placeholder="Enter certificate ID"
          className="border p-2 flex-1"
        />
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded disabled:bg-blue-400"
          disabled={loading}
        >
          {loading ? "Verifying..." : "Verify"}
        </button>
        {(query || result || error) && (
          <button
            type="button"
            onClick={handleClear}
            className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
          >
            Clear
          </button>
        )}
      </form>

      <div className="mt-6">
        {error && <div className="p-4 border rounded bg-red-50">{error}</div>}

        {result && (
          <div className="p-4 border rounded bg-green-50">
            <div className="mb-3 pb-3 border-b border-green-200">
              <p className="text-green-700 font-semibold">✅ Valid Certificate Found</p>
            </div>
            <h2 className="font-semibold text-lg mb-3">{result.domain}</h2>
            <p className="mb-2">Issued To: <span className="font-medium">{result.internName}</span></p>
            <p className="mb-2">Issued By: <span className="font-medium">Avijo</span></p>
            <p className="mb-2">
              Issued Date: <span className="font-medium">{result.issueDate ? new Date(result.issueDate).toLocaleDateString('en-GB') : "Pending"}</span>
            </p>
            <p className="mb-2">Certificate ID: <span className="font-medium">{result.certificateId}</span></p>
            <p>
              Status:{" "}
              <span
                className={
                  result?.status?.toUpperCase() === "VALID"
                    ? "text-green-600 font-semibold"
                    : "text-red-600 font-semibold"
                }
              >
                {result?.status?.toUpperCase()}
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CertificateValidation;
